// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.anonymousHeader {
  font-family: 'sofia-pro', sans-serif;
  width: 100%;
  height: 132px;
  line-height: 0;
  margin: 50px 0 0 0;
  overflow: hidden;
}
.anonymousHeader hr {
  display: none;
}
.anonymousHeader.stacked {
  height: auto;
}
.anonymousHeader.stacked h1 {
  margin-top: 50px;
  line-height: initial;
  text-align: center;
  padding-left: 40%;
  font-family: 'sofia-pro', sans-serif;
  font-weight: 800;
}
.anonymousHeader > .imgWrapper img {
  max-height: 80px;
  width: auto;
  height: 80px;
}
.anonymousHeader > h1 {
  width: 60%;
  padding: 0 0 0 0;
  margin: 0;
  text-align: left;
  font-size: 21px;
  line-height: 40px;
}
@media (max-width: 599px) {
  .anonymousHeader {
    height: auto;
    padding: 0;
    margin: 28px auto 28px auto;
  }
  .anonymousHeader > .imgWrapper {
    width: 90px;
  }
  .anonymousHeader > .imgWrapper img {
    max-height: 50px;
  }
  .anonymousHeader > h1 {
    font-size: 26px;
    line-height: 26px;
    width: min-content;
    max-width: 50%;
  }
  .anonymousHeader.stacked > h1 {
    margin-top: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/layouts/AnonymousHeader.less"],"names":[],"mappings":"AAGA;EACC,oCAAA;EACA,WAAA;EAEA,aAAA;EACA,cAAA;EACA,kBAAA;EAEA,gBAAA;AAJD;AAJA;EAWE,aAAA;AAJF;AAOC;EACC,YAAA;AALF;AAIC;EAKE,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oCAAA;EACA,gBAAA;AANH;AAlBA;EA8BG,gBAAA;EACA,WAAA;EACA,YAAA;AATH;AAvBA;EAqCE,UAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAXF;AAcC;EAAA;IACC,YAAA;IACA,UAAA;IACA,2BAAA;EAXA;EAQD;IAME,WAAA;EAXD;EAKD;IASG,gBAAA;EAXF;EAED;IAcE,eAAA;IACA,iBAAA;IACA,kBAAA;IACA,cAAA;EAbD;EAgBA;IAIE,gBAAA;EAjBF;AACF","sourcesContent":["@import (reference) '../constants.less';\n@import (reference) '../../commonComponents/constants.less';\n\n.anonymousHeader {\n\tfont-family: @sofiaFont;\n\twidth: 100%;\n\t@height: 132px;\n\theight: @height;\n\tline-height: 0; // I do not understand why this is zero instead of @height but it works...\n\tmargin: 50px 0 0 0;\n\t@innerWidth: 406px;\n\toverflow: hidden;\n\n\thr {\n\t\tdisplay: none;\n\t}\n\n\t&.stacked {\n\t\theight: auto;\n\t\t@innerWidth: 457px;\n\n\t\th1 {\n\t\t\tmargin-top: 50px;\n\t\t\tline-height: initial;\n\t\t\ttext-align: center;\n\t\t\tpadding-left: 40%;\n\t\t\tfont-family: @sofiaFont;\n\t\t\tfont-weight: 800;\n\t\t}\n\t}\n\n\t> .imgWrapper {\n\t\timg {\n\t\t\tmax-height: 80px;\n\t\t\twidth: auto;\n\t\t\theight: 80px;\n\t\t}\n\t}\n\n\t> h1 {\n\t\twidth: 60%;\n\t\tpadding: 0 0 0 0;\n\t\tmargin: 0;\n\t\ttext-align: left;\n\t\tfont-size: 21px;\n\t\tline-height: 40px;\n\t}\n\n\t@media (max-width: @phoneOnlyMaxWidth) {\n\t\theight: auto;\n\t\tpadding: 0;\n\t\tmargin: 28px auto 28px auto;\n\n\t\t> .imgWrapper {\n\t\t\twidth: 90px;\n\n\t\t\timg {\n\t\t\t\tmax-height: 50px;\n\t\t\t}\n\t\t}\n\n\t\t> h1 {\n\t\t\tfont-size: 26px;\n\t\t\tline-height: 26px;\n\t\t\twidth: min-content;\n\t\t\tmax-width: 50%;\n\t\t}\n\n\t\t&.stacked {\n\t\t\t@innerWidth: 200px;\n\n\t\t\t> h1 {\n\t\t\t\tmargin-top: 30px;\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
